<template>
  <div class="loading-spinner" :style="computedStyle">
    <div class="circle circle-1"></div>
    <div class="circle circle-2"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    size: {
      type: String,
      default: '40px',
    },
  },
  computed: {
    computedStyle() {
      return {
        height: this.size,
        width: this.size,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/variables";

.loading-spinner, .loading-spinner * {
  box-sizing: border-box;
}

.loading-spinner {
  border-radius: 100%;
  position: relative;
  display: inline-flex;
  margin: 16px;
}

.loading-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(60px / 10) solid transparent;
}

.loading-spinner .circle.circle-1 {
  border-top-color: $primary-blue;
  animation: half-circle-spinner-animation 1s infinite;
}

.loading-spinner .circle.circle-2 {
  border-bottom-color: #25AAEF;
  animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);

  }
  100%{
    transform: rotate(360deg);
  }
}
</style>
